import { computed, Injectable, signal } from "@angular/core";
import { MessageType } from "@core/enums/MessageType.enum";

@Injectable({
  providedIn: 'root',
})
export class MessageService {
  private message  = signal<string>('');
  private type = signal<MessageType | undefined>(undefined);

  showMessage = computed(() => !!this.message())
  getMessage = computed(() => this.message());
  getType = computed(() => this.type())

  loadMessage(message: string, type: MessageType){
    this.message.set(message);
    this.type.set(type);
    setTimeout(() => this.hideMessage() ,3000);
  }

  private hideMessage(){
    this.message.set('');
    this.type.set(undefined);
  }
}
